import { Box, Chip } from "@mui/material";
import type { FC } from "react";

export const TagChips: FC<{
  tags: string[];
  onDelete: (tag: string) => void;
}> = ({ tags, onDelete }) => {
  if (tags.length === 0) return null;

  return (
    <Box>
      {tags.map((tag) => {
        return (
          <Chip
            onDelete={() => onDelete(tag)}
            sx={{ mr: 1 }}
            label={tag}
            variant="outlined"
            key={tag}
            color="primary"
          />
        );
      })}
    </Box>
  );
};
